import React from 'react';
import { ErrorBoundary } from './error-boundary';
const BlinkErrorCodes = {
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    UPSTREAM_ERROR: 'UPSTREAM_ERROR',
    GRAPHQL_VALIDATION_ERROR: 'GRAPHQL_VALIDATION_ERROR',
    NO_ERROR: 'NO_ERROR',
};
const BlinkErrorBoundary = (properties) => (React.createElement(ErrorBoundary, { ...properties }));
export { BlinkErrorBoundary, BlinkErrorCodes };
//# sourceMappingURL=blink-error-boundary.js.map